export default class PrismApiError extends Error {
    constructor(private apiErrorMessage: string) {
        super(apiErrorMessage)
    }

    getApiErrorMessage() {
        return this.apiErrorMessage
    }
}
